"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const themes_1 = require("@targetx/mineral-ui/themes");
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const theme_1 = __importDefault(require("../../theme"));
const SignInScreen_1 = __importDefault(require("./SignInScreen"));
react_dom_1.default.hydrate(react_1.default.createElement(themes_1.ThemeProvider, { theme: theme_1.default }, react_1.default.createElement(SignInScreen_1.default, __PROPS__)), document.getElementById('root'));
